var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlob10X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.822266 6H10.8223M0.822266 6C0.822266 8.76142 3.06084 11 5.82227 11M0.822266 6C0.822266 3.23858 3.06084 1 5.82227 1M10.8223 6C10.8223 8.76142 8.58369 11 5.82227 11M10.8223 6C10.8223 3.23858 8.58369 1 5.82227 1M5.82227 1C7.07291 2.36918 7.78364 4.14602 7.82227 6C7.78364 7.85398 7.07291 9.63082 5.82227 11M5.82227 1C4.57163 2.36918 3.86089 4.14602 3.82227 6C3.86089 7.85398 4.57163 9.63082 5.82227 11",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlob10X);
export default __webpack_public_path__ + "static/media/glob-10x.8c6f855a5fd0f29c141acb8c1d6d8192.svg";
export { ForwardRef as ReactComponent };